import React from 'react';
import { Navigate } from 'react-router-dom';
import { getToken, getUserRole } from '../utils/auth';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = getToken();
  const role = getUserRole();
  if (!token || (allowedRoles && !allowedRoles.includes(role))) {
    return <Navigate to="/login" />;
  }
  return children;
};

export default ProtectedRoute;
